export const darkThemeColor = "#327788";

export const menuProps = {
	PaperProps: {
		style: {
			maxHeight: 200, // Set the maximum height of the dropdown
			overflowY: "auto", // Enable scrolling if content exceeds max height
		},
	},
};

export const customFieldsLabel ={
	translation: "תרגום",
	word_for_word: "מילה במילה",
	sanskrit: "סנסקריט",
	commentary: "התעמקות",
}